import { UserContext } from "@/lib/context";
import { useContext } from "react";

export const useUser = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("Please use within UserProvider");
  }

  return context;
};
